import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';
import {
    Center,
    Loader
} from '@mantine/core';

import {IndexPage} from './pages/IndexPage';
import {EditPage} from "./pages/EditPage.tsx";
import {SimulatePage} from "./pages/SimulatePage.tsx";
import {useVerifiedPermissions} from '@flexinet/auth-components';


export const RegistrationsLayout = () => {

    const {allowedActions, authorizing} = useVerifiedPermissions();

    // FNP-1731: allowedActions is empty until the check settles; deciding before
    // then sends a signed-in deep link away from the page it asked for.
    if (authorizing) {
        return <Center><Loader/></Center>;
    }

    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes('ListRegistrations') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes('GetRegistration') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/registrations'/>
                    )
                }
            />
            <Route
                path='simulate'
                element={
                    allowedActions.includes('SimulateRegistration') ? (
                        <SimulatePage/>
                    ) : (
                        <Navigate to='/registrations'/>
                    )
                }
            />
        </Routes>
    );
};
